import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useNavigate } from "react-router";

// components
import { RightArrow } from "components/common";

//utils
import { moneyFormatter } from "utils";

const ReceivableCard = ({ amount, isAll, ...props }) => {
  const navigate = useNavigate();

  return (
    <MainWrapper
      onClick={() =>
        isAll
          ? navigate("/sales/branch/receivable")
          : navigate("/sales/receivable")
      }
    >
      <Text>누적 미수금</Text>

      <AmountWrapper>
        <Text>{moneyFormatter(amount)}</Text>
        <RightArrow size="S" />
      </AmountWrapper>
    </MainWrapper>
  );
};

const MainWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 12px;
  padding: 24px;
  border-radius: 12px;
  height: 72px;
  background-color: ${(props) => props.theme.colors.cardBackground};
`;

const Text = styled.p`
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.primaryTextColor};
  font-feature-settings: "tnum" on, "lnum" on;
`;

const AmountWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  p {
    margin-right: 8px;
  }
`;

ReceivableCard.propTypes = {
  amount: PropTypes.number,
  isAll: PropTypes.bool,
};

export default ReceivableCard;
